export const API_NAME = "recipeCategory";
export const ROUTE_NAME = "recipeCategory";
export const COMPONENT_NAMES = ["Recipe Category", "Recipe Categories"];
